import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import EventDetailPage from "@/pages/EventDetailPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEvents from "@/pages/AdminEvents";
import AdminEventForm from "@/pages/AdminEventForm";
import AdminParticipants from "@/pages/AdminParticipants";
import AdminEmailTemplates from "@/pages/AdminEmailTemplates";

// Auth
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id - must be synchronous, before ProtectedRoute
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/evenement/:eventId" element={<EventDetailPage />} />
      <Route path="/confirmation" element={<ConfirmationPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      
      {/* Admin routes - protected */}
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/evenements" element={<ProtectedRoute><AdminEvents /></ProtectedRoute>} />
      <Route path="/admin/evenements/nouveau" element={<ProtectedRoute><AdminEventForm /></ProtectedRoute>} />
      <Route path="/admin/evenements/:eventId" element={<ProtectedRoute><AdminEventForm /></ProtectedRoute>} />
      <Route path="/admin/evenements/:eventId/participants" element={<ProtectedRoute><AdminParticipants /></ProtectedRoute>} />
      <Route path="/admin/emails" element={<ProtectedRoute><AdminEmailTemplates /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-[#FFFDF7]">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
